var _path, _path2, _circle, _circle2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _line3, _line4, _line5, _circle3, _circle4, _g2, _path9, _path10, _path11, _path12, _path13, _path14, _line6, _line7, _line8, _line9, _line10, _circle5, _circle6, _g3, _path15, _path16, _path17, _path18, _line11, _line12, _line13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeAboutUsEvent2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 371,
    viewBox: "0 0 429 371",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_596_14612)",
    filter: "url(#filter0_b_596_14612)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 102.214C0 51.1071 0 25.5536 11.583 12.7768C23.166 0 46.332 0 92.664 0H336.336C382.668 0 405.834 0 417.417 12.7768C429 25.5536 429 51.1071 429 102.214V268.786C429 319.893 429 345.446 417.417 358.223C405.834 371 382.668 371 336.336 371H120.5C74.168 371 23.166 371 11.583 358.223C0 345.446 0 319.893 0 268.786V102.214Z",
    fill: "#31195D",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.872 74L34.688 74L34.688 41.84L57.488 41.84L57.488 46.496L39.872 46.496L39.872 56.432L56.768 56.432L56.768 61.136L39.872 61.136L39.872 74ZM72.0193 74.48C64.6753 74.48 60.1152 69.488 60.1152 62.048C60.1152 54.656 64.6753 49.664 72.0193 49.664C79.3153 49.664 83.7313 54.656 83.7313 62.048C83.7313 69.488 79.3153 74.48 72.0193 74.48ZM72.0193 69.872C77.0113 69.872 78.7393 67.424 78.7393 62.048C78.7393 56.72 77.0113 54.272 72.0193 54.272C66.9793 54.272 65.2033 56.72 65.2033 62.048C65.2033 67.424 66.9793 69.872 72.0193 69.872ZM98.7849 74.48C91.4409 74.48 86.8809 69.488 86.8809 62.048C86.8809 54.656 91.4409 49.664 98.7849 49.664C106.081 49.664 110.497 54.656 110.497 62.048C110.497 69.488 106.081 74.48 98.7849 74.48ZM98.7849 69.872C103.777 69.872 105.505 67.424 105.505 62.048C105.505 56.72 103.777 54.272 98.7849 54.272C93.7449 54.272 91.9689 56.72 91.9689 62.048C91.9689 67.424 93.7449 69.872 98.7849 69.872ZM124.122 74C118.794 74 116.01 72.032 116.01 66.656L116.01 54.464L112.026 54.464L112.026 50.144L116.106 50.144L117.21 44.24L121.194 44.24L121.194 50.144L128.394 50.144L128.394 54.464L121.194 54.464L121.194 66.416C121.194 68.912 122.25 69.344 125.466 69.344L128.394 69.344L128.394 73.568C127.386 73.808 125.754 74 124.122 74ZM136.843 74L132.091 74L132.091 41.84L137.275 41.84L137.275 53.936H137.371C138.427 51.776 141.163 49.664 145.387 49.664C151.963 49.664 155.419 54.512 155.419 62.048C155.419 69.632 151.771 74.48 145.099 74.48C140.971 74.48 138.187 72.848 137.035 70.064H136.843L136.843 74ZM137.275 64.208C137.275 68.192 139.579 70.064 143.755 70.064C148.363 70.064 150.283 67.952 150.283 62.048C150.283 56.192 148.315 54.08 143.755 54.08C139.579 54.08 137.275 55.952 137.275 59.936L137.275 64.208ZM166.041 74.48C161.769 74.48 158.457 72.272 158.457 68.096C158.457 64.16 161.337 62.096 166.425 61.376L174.777 60.128V58.832C174.777 55.28 173.145 54.224 169.401 54.224C165.609 54.224 164.121 55.424 164.121 58.592V59.312L159.129 59.312V58.832C159.129 53.504 163.305 49.664 169.689 49.664C176.361 49.664 179.721 53.696 179.721 59.504L179.721 74L174.921 74L174.921 70.256L174.681 70.256C173.289 72.512 170.553 74.48 166.041 74.48ZM163.497 67.712C163.497 69.584 164.697 70.352 167.721 70.352C171.081 70.352 174.777 69.008 174.777 64.208V63.776L167.193 64.928C164.457 65.312 163.497 65.936 163.497 67.712ZM189.869 74L184.685 74L184.685 41.84L189.869 41.84L189.869 74ZM200.322 74L195.138 74L195.138 41.84L200.322 41.84L200.322 74Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 196.352,
    cy: 309.543,
    r: 89.1,
    transform: "rotate(-179.438 196.352 309.543)",
    stroke: "#8567C0",
    strokeWidth: 16.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_596_14612",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 212,
    width: 195,
    height: 195
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.351,
    cy: 309.543,
    r: 97.2,
    transform: "rotate(-179.438 196.351 309.543)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_596_14612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.661 481.766L158.924 367.994L157.16 362.379L151.276 362.322L32.0283 361.151L129.189 292.006L133.984 288.594L132.22 282.979L96.484 169.207L192.269 240.245L196.996 243.751L201.791 240.339L298.952 171.194L260.99 284.243L259.116 289.822L263.843 293.328L359.628 364.366L240.381 363.196L234.496 363.138L232.623 368.717L194.661 481.766Z",
    stroke: "#8567C0",
    strokeWidth: 16.2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.448 299.838L196.649 279.057L225.436 300.407L214.027 334.383L178.188 334.031L167.448 299.838Z",
    fill: "#8567C0",
    stroke: "#8567C0",
    strokeWidth: 16.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.954 390.856L264.661 364.89L234.287 364.592L227.954 390.856Z",
    fill: "#8567C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M163.161 390.22L126.971 363.539L157.345 363.837L163.161 390.22Z",
    fill: "#8567C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.257 300.598L126.663 258.736L134.236 288.152L110.257 300.598Z",
    fill: "#8567C0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M284.194 302.305L268.613 260.129L260.464 289.39L284.194 302.305Z",
    fill: "#8567C0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211.415 221.669L178.752 231.361L202.663 237.091L211.415 221.669Z",
    fill: "#8567C0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 233.894,
    y1: 360.215,
    x2: 216.439,
    y2: 337.952,
    stroke: "#8567C0",
    strokeWidth: 4.41818
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -2.20909,
    x2: 28.2902,
    y2: -2.20909,
    transform: "matrix(0.632327 -0.774701 -0.774701 -0.632327 156.108 358.072)",
    stroke: "#8567C0",
    strokeWidth: 4.41818
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -2.20909,
    x2: 28.2902,
    y2: -2.20909,
    transform: "matrix(0.00981269 -0.999952 -0.999952 -0.00981269 194.442 278.916)",
    stroke: "#8567C0",
    strokeWidth: 4.41818
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -2.20909,
    x2: 28.2902,
    y2: -2.20909,
    transform: "matrix(-0.939516 -0.342506 -0.342506 0.939516 161.091 300.684)",
    stroke: "#8567C0",
    strokeWidth: 4.41818
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 226.481,
    y1: 299.243,
    x2: 253.245,
    y2: 290.077,
    stroke: "#8567C0",
    strokeWidth: 4.41818
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.185,
    cy: 184.774,
    r: 89.1,
    transform: "rotate(-179.438 363.185 184.774)",
    stroke: "#8567C0",
    strokeWidth: 16.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_596_14612",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 265,
    y: 87,
    width: 196,
    height: 195
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.185,
    cy: 184.774,
    r: 97.2,
    transform: "rotate(-179.438 363.185 184.774)",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_596_14612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.495 356.998L325.758 243.225L323.994 237.61L318.11 237.553L198.862 236.383L296.023 167.237L300.818 163.825L299.054 158.211L263.318 44.438L359.103 115.477L363.83 118.982L368.625 115.57L465.786 46.4249L427.824 159.474L425.95 165.053L430.677 168.559L526.462 239.597L407.215 238.427L401.33 238.369L399.457 243.948L361.495 356.998Z",
    stroke: "#8567C0",
    strokeWidth: 16.2
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M334.281 175.069L363.482 154.288L392.269 175.638L380.86 209.614L345.021 209.262L334.281 175.069Z",
    fill: "#8567C0",
    stroke: "#8567C0",
    strokeWidth: 16.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M394.787 266.087L431.494 240.121L401.12 239.823L394.787 266.087Z",
    fill: "#8567C0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M329.994 265.451L293.804 238.77L324.178 239.068L329.994 265.451Z",
    fill: "#8567C0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M277.089 175.83L293.495 133.967L301.068 163.383L277.089 175.83Z",
    fill: "#8567C0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M451.027 177.537L435.446 135.36L427.297 164.622L451.027 177.537Z",
    fill: "#8567C0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M378.248 96.9L345.585 106.592L369.496 112.322L378.248 96.9Z",
    fill: "#8567C0"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 400.727,
    y1: 235.446,
    x2: 383.272,
    y2: 213.183,
    stroke: "#8567C0",
    strokeWidth: 4.41818
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -2.20909,
    x2: 28.2902,
    y2: -2.20909,
    transform: "matrix(0.632327 -0.774701 -0.774701 -0.632327 322.941 233.303)",
    stroke: "#8567C0",
    strokeWidth: 4.41818
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -2.20909,
    x2: 28.2902,
    y2: -2.20909,
    transform: "matrix(0.00981269 -0.999952 -0.999952 -0.00981269 361.275 154.147)",
    stroke: "#8567C0",
    strokeWidth: 4.41818
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    y1: -2.20909,
    x2: 28.2902,
    y2: -2.20909,
    transform: "matrix(-0.939516 -0.342506 -0.342506 0.939516 327.925 175.916)",
    stroke: "#8567C0",
    strokeWidth: 4.41818
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 393.314,
    y1: 174.474,
    x2: 420.078,
    y2: 165.308,
    stroke: "#8567C0",
    strokeWidth: 4.41818
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 369.608,
    cy: 369.886,
    r: 71.28,
    transform: "rotate(-179.438 369.608 369.886)",
    stroke: "#8567C0",
    strokeWidth: 12.96
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_596_14612",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 291,
    y: 292,
    width: 157,
    height: 156
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 369.608,
    cy: 369.886,
    r: 77.76,
    transform: "rotate(-179.438 369.608 369.886)",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_596_14612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.256 507.665L339.667 416.647L338.256 412.155L333.548 412.109L238.15 411.173L315.879 355.857L319.715 353.127L318.304 348.635L289.715 257.617L366.343 314.448L370.125 317.253L373.961 314.523L451.689 259.207L421.319 349.646L419.821 354.109L423.602 356.914L500.23 413.745L404.833 412.808L400.125 412.762L398.626 417.225L368.256 507.665Z",
    stroke: "#8567C0",
    strokeWidth: 12.96
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M346.485 362.122L369.846 345.497L392.876 362.577L383.749 389.758L355.078 389.477L346.485 362.122Z",
    fill: "#8567C0",
    stroke: "#8567C0",
    strokeWidth: 12.96
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M300.732 362.73L313.857 329.241L319.915 352.773L300.732 362.73Z",
    fill: "#8567C0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M439.882 364.096L427.417 330.355L420.898 353.764L439.882 364.096Z",
    fill: "#8567C0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M381.66 299.587L355.53 307.34L374.658 311.924L381.66 299.587Z",
    fill: "#8567C0"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    y1: -1.76727,
    x2: 22.6321,
    y2: -1.76727,
    transform: "matrix(0.00981269 -0.999952 -0.999952 -0.00981269 368.081 345.384)",
    stroke: "#8567C0",
    strokeWidth: 3.53455
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    y1: -1.76727,
    x2: 22.6321,
    y2: -1.76727,
    transform: "matrix(-0.939516 -0.342506 -0.342506 0.939516 341.401 362.799)",
    stroke: "#8567C0",
    strokeWidth: 3.53455
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 393.713,
    y1: 361.646,
    x2: 415.124,
    y2: 354.313,
    stroke: "#8567C0",
    strokeWidth: 3.53455
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_596_14612",
    x: -4,
    y: -4,
    width: 437,
    height: 379,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_596_14612"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_596_14612",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_596_14612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 429,
    height: 371,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAboutUsEvent2);
export default __webpack_public_path__ + "static/media/home-about-us-event-2.674d4a3e225f24690ecf7e7b6326e64d.svg";
export { ForwardRef as ReactComponent };